import { createServiceClient } from "shared/welda/services/axiosClient";

const api = createServiceClient("/events");

const loadGuestLogin = async (data) =>
  await api.post(`/load-guest-login`, data);

const cookieService = {
  loadGuestLogin,
};

export default cookieService;
